import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';

export function ConsentActions({ onAccept, onClose }) {
  const { t } = useTranslation();
  
  return (
    <div className="bg-gray-50 px-6 py-3 flex flex-row-reverse">
      <button
        type="button"
        onClick={onAccept}
        className="inline-flex justify-center rounded-md border border-transparent px-4 py-2 bg-indigo-600 text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 ml-3 w-auto text-sm font-medium"
      >
        {t('consent.actions.accept')}
      </button>
      <button
        type="button"
        onClick={onClose}
        className="inline-flex justify-center rounded-md border border-gray-300 px-4 py-2 bg-white text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 w-auto text-sm font-medium"
      >
        {t('consent.actions.cancel')}
      </button>
    </div>
  );
} 